/**
 * The checkmate/stalemate result-modal delay (lifecycle row 43, fix E10) —
 * genuinely different per platform, so it is a SEAM rather than a branch
 * inside the shared `reducers/game.ts` (which must stay platform-free,
 * `__tests__/platformFree.test.ts`).
 *
 * Old web `index.js` L3050-3055 waits 1.5 s; old app `index.tsx` L4603-4606
 * waits a full 2 s. ADAPTED: the web ships this value, the app its own
 * (`Store/liveGame/SYNC.md` "Adapted files") — never compared by
 * `tools/live-game-drift.sh`.
 */
export const MODAL_DELAY_MS = 1500;

export default MODAL_DELAY_MS;
